<template>
  <div class="appointment-landing">
    <Dialog class="appointment-dialog" v-model="showAppointmentDialog">
      <div class="appointment-dialog_wrapper">
        <div class="left-side" v-if="!isAuth">
          <Auth @close="showAppointmentDialog = false" />
        </div>
        <div class="right-side" v-if="doctor">
          <button v-if="isAuth" @click="showAppointmentDialog = false" class="sign-in-dialog_close-button">
            <i class="material-icons">close</i>
          </button>
          <div v-if="!isAuth" class="hint-overlay">
            <div class="hint"> 
              <i class="material-icons">arrow_back_ios</i>
              <span>Для записи к врачу необходимо авторизоваться</span>
            </div>
          </div>
          <div class="fullinfo-wrap">
            <div class="avatar">
              <div v-if="doctor.avatar" class="image-background" :style="{ backgroundImage: `url(${doctor.avatar})` }"></div>
              <img v-else class="placeholder" src="@/assets/user.svg" alt="Аватар">
            </div>
            <div class="info-wrap">
              <div class="name">{{ doctor.fullName }}</div>
              <div class="description">{{ doctor.department }}</div>
              <div class="type">{{ isOnline ? 'Онлайн консультация' : 'Частный прием' }}</div>
              <div class="appointment-time">
                <div class="date" v-if="selectedDateFomatter">
                  <i class="material-icons">calendar_today</i>
                  <span>{{ selectedDateFomatter }}</span>
                </div>
                <div class="time" v-if="selectedTimeslot">
                  <i class="material-icons">access_time</i>
                  <span>{{ selectedTimeslot.label }}</span>
                </div>
              </div>
            </div>
          </div>
          <button type="button" @click="appointmentSlot" class="appointment-dialog-button">
            Записаться
          </button>
        </div>
      </div>
    </Dialog>
    <v-select
      class="landing-selector"
      placeholder="Выберите специальность..."
      label="title"
      v-model="specialty"
      :reduce="data => data.id"
      :clearable="false"
      :options="specialties">
      <template #open-indicator="{ attributes }">
        <i class="material-icons" v-bind="attributes">keyboard_arrow_down</i>
      </template>
    </v-select>
    <div class="doctor-list">
      <template v-if="!doctor && !loading">
        <div class="doctor-item" v-for="doctor in doctors" :key="doctor.id">
          <div class="top">
            <div class="avatar">
              <img v-if="doctor.avatar" :src="doctor.avatar" alt="Аватар">
              <img v-else class="placeholder" src="@/assets/user.svg" alt="Аватар">
            </div>
            <div class="right-side">
              <div class="name">{{ doctor.fullName }}</div>
              <div class="department">{{ doctor.department }}</div>
              <div class="actions">
                <button @click="selectDoctor(doctor)">
                  <span>Прием</span>
                </button>
                <button @click="selectOfflineDoctor(doctor)">
                  <span>Онлайн-консультация</span>
                </button>
              </div>
            </div>
          </div>
          <div class="bottom">
            <button @click="selectDoctor(doctor)">
              <span>Прием</span>
            </button>
            <button @click="selectOfflineDoctor(doctor)">
              <span>Онлайн-консультация</span>
            </button>
          </div>
        </div>
      </template>
      <template v-if="loading">
        <div class="doctor-item doctor-loading">
          <div class="top">
            <div class="avatar">
            </div>
            <div class="right-side">
              <div class="name"></div>
              <div class="department"></div>
              <div class="actions">
                <div class="room"></div>
                <div class="web"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="doctor-item doctor-loading">
          <div class="top">
            <div class="avatar">
            </div>
            <div class="right-side">
              <div class="name"></div>
              <div class="department"></div>
              <div class="actions">
                <div class="room"></div>
                <div class="web"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="doctor-item doctor-loading">
          <div class="top">
            <div class="avatar">
            </div>
            <div class="right-side">
              <div class="name"></div>
              <div class="department"></div>
              <div class="actions">
                <div class="room"></div>
                <div class="web"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="doctor-placeholder" v-if="specialty && !loading && !doctors.length">
        <img src="@/assets/user-list.svg" alt="">
        <span>Список докторов пуст...</span>
      </div>

      <div v-if="doctor" class="doctor-item">
        <div class="top">
          <div class="avatar">
            <img v-if="doctor.avatar" :src="doctor.avatar" alt="Аватар">
            <img v-else class="placeholder" src="@/assets/user.svg" alt="Аватар">
          </div>
          <div class="right-side">
            <div class="name">{{ doctor.fullName }}</div>
            <div class="department">{{ doctor.department }}</div>
            <div class="actions">
              <div class="button-group">
                <button @click="isOnline = false" :class="{ active: !isOnline }">Прием</button>
                <button @click="isOnline = true" :class="{ active: isOnline }">Онлайн-консультация</button>
              </div>
              <button @click="doctor = null">
                <span>Поменять врача</span>
              </button>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="button-group">
            <button @click="isOnline = false" :class="{ active: !isOnline }">Прием</button>
            <button @click="isOnline = true" :class="{ active: isOnline }">Онлайн-консультация</button>
          </div>
          <button @click="doctor = null">
            <span>Поменять врача</span>
          </button>
        </div>
      </div>

      <div v-if="doctor" class="time-select">
        <vc-date-picker
          ref="datepicker"
          @update:from-page="changeMounth"
          v-model="selectDate"
          :available-dates="availableDates"
          class="date-selector"
          title-position="left"
        />
        <div class="right-side" v-if="selectDate">
          <div v-if="loadingTimeslots" class="loading-times">
            <div class="spinner"></div>
          </div>
          <div class="empty-times" v-if="!timeslots.length">
            <div class="empty-times_icon">
              <img :src="emptyTimeIcon" alt="Слотов нет">
            </div>
            <div class="empty-times_text">
              Все записи заняты
            </div>
          </div>
          <div class="times">
            <button
              v-for="timeslot in timeslots"
              @click="selectTimeslot(timeslot)"
              :key="timeslot.id"
              :class="{ selected: selectedTimeslot && (selectedTimeslot.id === timeslot.id) }"
              class="time">
              {{ timeslot.label }}
            </button>
          </div>
          <button
            v-if="timeslots.length"
            @click="showAppointmentDialog = true"
            class="time-button"
            :disabled="isDisabled">
            Записаться
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { specialtyApi, doctorApi, chatApi } from '@app/services';
import dateUrlIcon from '@app/assets/date.svg';
import webUrlIcon from '@app/assets/web.svg';
import emptyTimeIcon from '@app/assets/empty-time.svg';
import { timetableApi } from '@app/services';
import Dialog from '@app/components/uikit/Dialog';
import Auth from '../dialogs/auth';


export default {
  components: {
    Dialog,
    Auth,
  },
  data: () => ({
    isSignIn: true,
    showAppointmentDialog: false,
    availableDates: {
      days: []
    },
    fetchDate: [],
    selectDate: null,
    dateUrlIcon,
    webUrlIcon,
    emptyTimeIcon,
    selectedTimeslot: null,
    timeslots: [],
    doctor: null,
    doctors: [],
    specialty: null,
    specialties: [],
    loading: false,
    isOnline: false,
    loadingTimeslots: false,
  }),
  computed: {
    isAuth() {
      return this.$store.state.auth.is_auth;
    },
    selectedDateFomatter() {
      return this.selectDate ? moment(this.selectDate).format('DD.MM.YYYY') : null;
    },
    isDisabled() {
      return !this.selectedTimeslot;
    },
  },
  async created() {
    this.loadSpecialtyList();
  },
  watch: {
    isAuth(value) {
      if (!value) {
        return;
      }
      this.presetAppointment();
    },
    showAppointmentDialog(value) {
      const { id, label, record_mode } = this.selectedTimeslot;
      const { avatar, department, fullName, id: doctroId } = this.doctor;
      const selectDate = this.selectDate;
      localStorage.setItem('showAppointmentDialog', value);
      localStorage.setItem('isOnline', this.isOnline);
      localStorage.setItem('timeslot.id', id);
      localStorage.setItem('timeslot.label', label);
      localStorage.setItem('timeslot.record_mode', record_mode);
      localStorage.setItem('doctor.id', doctroId);
      localStorage.setItem('doctor.avatar', avatar ? avatar : '');
      localStorage.setItem('doctor.department', department);
      localStorage.setItem('doctor.fullName', fullName);
      localStorage.setItem('selectDate', selectDate);
    },
    selectDate(value) {
      this.selectedTimeslot = null;
      const date = moment(value).format('YYYY-MM-DD');
      this.loadTimeslots(this.doctor.id, date);
    },
    specialty(value) {
      this.loadDoctorList(value);
    }
  },
  methods: {
    async presetAppointment() {
      const isOpened = localStorage.getItem('showAppointmentDialog') ?
        (localStorage.getItem('showAppointmentDialog') === 'true' ? true : false)
        : false;
      if (isOpened) {
        const id = localStorage.getItem('doctor.id');
        const avatar = localStorage.getItem('doctor.avatar');
        const department = localStorage.getItem('doctor.department');
        const fullName = localStorage.getItem('doctor.fullName');
        const isOnline = localStorage.getItem('isOnline');
        const selectDate = localStorage.getItem('selectDate');
        const timeslotId = localStorage.getItem('timeslot.id');
        const label = localStorage.getItem('timeslot.label');
        const record_mode = localStorage.getItem('timeslot.record_mode');
        const timeslot = { id: timeslotId, label, record_mode };
        const doctor = { id, avatar, department, fullName };
        this.isOnline = isOnline;
        if (this.isOnline) {
          await this.selectDoctor(doctor);
        } else {
          await this.selectOfflineDoctor(doctor);
        }
        const datepicker = this.$refs.datepicker;
        const date = moment(new Date(selectDate)).format('YYYY.MM');
        await datepicker.move(date);
        this.selectDate = new Date(selectDate);
        await new Promise(resolve => setTimeout(resolve, 2000));
        this.selectTimeslot(timeslot);
        this.showAppointmentDialog = true;
      }
    },
    async appointmentSlot() {
      const { id, label } = this.selectedTimeslot;
      const type = this.isOnline ? 1 : 0;
      await timetableApi.reserveSlot(id, { type });
      if (this.isOnline) {
        const fullName = `${ this.$store.state.auth.user.last_name } ${ this.$store.state.auth.user.first_name }`;
        const date = `${ moment(this.selectDate).format('YYYY-MM-DD') } ${ label }`;
        const name = `Комната приема пациента: ${fullName} ${date}`;
        await chatApi.createPrivateChat(id, name);
      }
      this.$emit('appointment', id);
      const date = moment(this.selectDate).format('YYYY-MM-DD');
      this.loadTimeslots(this.doctor.id, date);
      this.showAppointmentDialog = false;
    },
    parseMounthDate(year, month) {
      const format = 'YYYY-MM-DD';
      const pageDate = `${year} ${month}`;
      const date = moment(pageDate, 'YYYY MM');
      const start = date.startOf('month').format(format);
      const end = date.endOf('month').format(format);
      return { start, end };
    },
    async changeMounth({ month, year }) {
      const { id } = this.doctor;
      const { start, end } = this.parseMounthDate(year, month);
      const { items } = await doctorApi.getAvalibleDates(id, start, end);
      const dates = items.map(item => moment(item.date).toDate());
      this.availableDates = dates.length ? dates : { days: [] };
    },
    selectTimeslot(timeslot) {
      this.selectedTimeslot = timeslot;
    },
    selectDoctor(doctor) {
      this.doctor = doctor;
      this.selectDate = null;
      this.isOnline = false;
    },
    selectOfflineDoctor(doctor) {
      this.doctor = doctor;
      this.selectDate = null;
      this.isOnline = true;
    },
    async loadTimeslots(id, date) {
      this.loadingTimeslots = true;
      const { items } = await doctorApi.getAvalibleSlotsByDate(id, date);
      this.timeslots = items.map(({ id, start_time, record_mode }) => ({
        id,
        label: start_time.slice(-8, -3),
        record_mode
      }));
      this.loadingTimeslots = false;
    },
    async loadDoctorList(uuid) {
      this.doctor = null;
      this.loading = true;
      const { items } = await doctorApi.getBySpecialty(uuid);
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.doctors = items.map(item => {
        const { id, employee, department } = item;
        const { avatar, lastName, firstName, middleName } = employee;
        const fullName = `${lastName} ${firstName} ${middleName}`;
        return { id, avatar, fullName, department: department.title };
      });
      this.loading = false;
    },
    async loadSpecialtyList() {
      const { items } = await specialtyApi.getAll();
      this.specialties = items.map(item => ({ ...item, selected: false }));
    },
  }
};
</script>

<style scoped>
.appointment-dialog .bottom.flex-center {
  justify-content: center;
}
.appointment-dialog button {
  outline: 0;
}
.appointment-dialog .appointment-dialog_wrapper {
  display: flex;
}
.appointment-dialog .appointment-dialog_wrapper .right-side {
  position: relative;
  padding: 1rem 2rem;
  max-width: 260px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.appointment-dialog .appointment-dialog_wrapper .hint-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0,0,0,.45);
  box-shadow: inset 18px 0 24px -24px rgba(0, 0, 0, 0.2);
  color: #fff;
  z-index: 1;
  font-weight: 300;
  padding: 1rem;
  display: flex;
  align-items: flex-start;
}
.appointment-dialog .appointment-dialog_wrapper .hint-overlay .hint {
  display: flex;
  align-items: center;
  font-size: 14px;
}
.appointment-dialog .appointment-dialog_wrapper .hint-overlay i {
  margin-right: 0.2rem;
}
.appointment-dialog .appointment-dialog_wrapper .right-side .avatar {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 0 10px 4px rgba(0,0,0,0.03);
  background-color: #fff;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.appointment-dialog .appointment-dialog_wrapper .right-side .avatar img.placeholder {
  width: 80px;
  height: 80px;
}
.appointment-dialog .appointment-dialog_wrapper .right-side .name {
  font-size: 18px;
  text-align: center;
  line-height: 1.2;
  color: #636363;
}
.appointment-dialog .appointment-dialog_wrapper .right-side .description {
  color: #707070;
  font-size: 12px;
  margin-top: 0.3rem;
}
.appointment-dialog .appointment-dialog_wrapper .right-side .appointment-time {
  display: flex;
  margin-top: 1rem;
  font-size: 14px;
  justify-content: center;
}
.appointment-dialog .appointment-dialog_wrapper .right-side .appointment-time .date,
.appointment-dialog .appointment-dialog_wrapper .right-side .appointment-time .time {
  display: flex;
  align-items: center;
  color: rgb(75, 75, 75);
}
.appointment-dialog .appointment-dialog_wrapper .right-side .appointment-time .date i,
.appointment-dialog .appointment-dialog_wrapper .right-side .appointment-time .time i {
  color: #777777;
  margin-right: 0.2rem;
  font-size: 20px;
}
.appointment-dialog .appointment-dialog_wrapper .right-side .appointment-time .date {
  margin-right: 12px;
}
.appointment-dialog .appointment-dialog_wrapper .right-side .avatar .image-background {
  background-size: cover;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.appointment-dialog .appointment-dialog_wrapper .right-side .appointment-dialog-button {
  background-color: #5abfda;
  border: 1px solid #5abfda;
  text-align: center;
  color: #fff;
  width: 100%;
  height: 36px;
  border-radius: 4px;
  font-weight: 300;
  outline: 0;
  margin-top: 1rem;
}
.appointment-dialog .right-side {
  background-color: rgb(245, 245, 245);
  flex: auto;
}
.date-selector {
  border: 0;
  box-shadow: 0 3px 7px 3px rgba(0, 0, 0, .04);
  border-radius: 4px;
}
.landing-selector {
  background-color: white;
  border: 1px solid rgba(0,0,0,.1);
  border-radius: 24px;
  height: 48px;
  display: flex;
  padding: 0 1rem;
  align-items: center;
  transition: box-shadow 200ms ease, border 200ms ease;
  width: 100%;
  margin: 0;
}
.doctor-list .doctor-item {
  background-color: #ffffff;
}
.doctor-item {
  margin: 12px 0;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 3px 7px 3px rgba(0, 0, 0, .04);
}
.doctor-item .top {
  padding: 12px;
  display: flex;
}
.doctor-item .bottom {
  border-top: 1px solid rgb(238, 237, 237);
  justify-content: space-between;
  padding: 6px;
  display: none;
}
.doctor-item .bottom button {
  background-color: transparent;
  font-size: 12px;
  padding: 6px 12px;
  font-weight: 500;
  border-radius: 4px;
  color: #747474;
  outline: 0;
}
.doctor-item .bottom .button-group {
  border: 1px solid rgba(0, 0, 0, .1);
  border-radius: 4px;
  overflow: hidden;
  display: flex;
}
.doctor-item .bottom .button-group button {
  border-radius: 0;
  border: 0;
}
.doctor-item .bottom .button-group button.active {
  background-color: rgba(0, 0, 0, .1);
}
.doctor-item .bottom button:hover {
  background-color: rgba(0, 0, 0, .03);
}
.doctor-item .avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  flex: 0 0 100px;
  border-radius: 50%;
  overflow: hidden;
  background-color: rgba(0,0,0,.05);
}
.doctor-item .avatar .placeholder {
  width: 60px;
}
.doctor-item .name {
  font-size: 18px;
  font-weight: 300;
  color: #636363;
  margin-left: 12px;
  line-height: 1;
}
.doctor-item .avatar img {
  max-height: 100%;
  max-width: 100%;
}
.doctor-item .right-side {
  flex: auto;
  display: flex;
  flex-direction: column;
  margin-left: 12px;
  margin-top: 12px;
}
.doctor-item .department {
  color: #a0a0a0;
  font-size: 12px;
  margin-top: 6px;
  margin-left: 12px;
  line-height: 1;
}
.doctor-item .actions {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
}
.doctor-item .actions button {
  font-weight: 500;
  background-color: transparent;
  font-size: 12px;
  color: #747474;
  padding: 6px 12px;
  border-radius: 4px;
  transition: background-color 300ms ease;
  outline: 0;
}
.doctor-item .actions button:hover {
  background-color: rgba(0, 0, 0, .03);
}
.doctor-item .actions .button-group button.active {
  background-color: rgba(0, 0, 0, .1);
}
.doctor-item .actions .button-group button:first-child {
  margin-right: 6px;
}
.doctor-placeholder {
  color: #c9c9c9;
  font-size: 16px;
  font-weight: 300;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12px 0;
}
.doctor-placeholder img {
  width: 70px;
}

.doctor-item.doctor-loading {
  background-color: #fff;
}
.doctor-item.doctor-loading .name {
  width: 70%;
  height: 18px;
  background-color: rgba(0,0,0,.05);
  border-radius: 4px;
}
.doctor-item.doctor-loading .department {
  width: 50%;
  height: 12px;
  background-color: rgba(0,0,0,.05);
  border-radius: 4px;
}
.doctor-item.doctor-loading .room,
.doctor-item.doctor-loading .web {
  width: 40%;
  background-color: rgba(0,0,0,.05);
  height: 30px;
  border-radius: 4px;
}
.doctor-item.doctor-loading .avatar,
.doctor-item.doctor-loading .name,
.doctor-item.doctor-loading .department,
.doctor-item.doctor-loading .room,
.doctor-item.doctor-loading .web {
  animation: pulse 1.3s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    background-color: rgba(0, 0, 0, 0.05);
  }
  50% {
    background-color: rgba(0, 0, 0, 0.1);
  }
  100% {
    background-color: rgba(0, 0, 0, 0.05);
  }
}
.time-select {
  display: flex;
}
.time-select .right-side {
  background-color: #fff;
  border-radius: 4px;
  flex: auto;
  margin-left: 12px;
  box-shadow: 0 3px 7px 3px rgba(0, 0, 0, .04);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}
.time-select .right-side button.time-button {
  width: 100%;
  background-color: transparent;
  height: 42px;
  background-color: rgba(0, 0, 0, .02);
  color: #636363;
  outline: 0;
}
.time-select .right-side button.time-button:disabled {
  opacity: 0.4;
}
.time-select .times {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.time-select .time {
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  background-color: transparent;
  outline: 0;
}
.time-select .time:hover {
  background: none;
  background-color: rgba(0, 0, 0, .03);
}
.time-select .time.selected {
  background: none;
  background-color: rgba(0, 0, 0, .07);
}
.empty-times {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  padding: 2rem;
}
.empty-times_icon {
  width: 100px;
}
.empty-times_icon img {
  display: block;
  max-width: 100%;
  max-height: 100%;
}
.empty-times_text {
  color: #c9c9c9;
  font-weight: 300;
  font-size: 18px;
  padding-top: 24px;
}
.loading-times {
  z-index: 10;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, .7);
}
.spinner {
  display: inline-block;
  width: 80px;
  height: 80px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.spinner:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid red;
  border-color: rgb(110, 180, 197) transparent rgb(110, 180, 197) transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fullinfo-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.appointment-dialog_wrapper .left-side {
  position: relative;
}
.sign-in-dialog_title {
  width: 300px;
  font-weight: 600;
  text-align: center;
  padding-top: 0.5rem;
  font-size: 1.5rem;
  color: #424242;
}
.social-auth {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
}
form {
  padding: 1rem;
}
.g-signin-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.g-signin-button svg {
  width: 20px;
}
.fb-signin-button {
  width: 40px;
  border-radius: 50%;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.social-link {
  display: block;
  width: 40px;
  border-radius: 50%;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.social-link svg {
  width: 40px;
}
.yandex-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  border-radius: 50%;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.yandex-link svg {
  height: 20px;
  width: 40px;
  margin-right: 2px;
}
.odnoklassniki-link {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ff9801;
  width: 40px;
  border-radius: 50%;
  height: 40px;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.odnoklassniki-link svg {
  color: #fff;
  width: 20px;
}
.blank-link {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  width: 40px;
  border-radius: 50%;
  height: 40px;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.blank-link svg {
  width: 20px;
}
.diviner {
  position: relative;
  height: 1px;
  width: 100%;
  border-top: 1px solid rgb(219, 219, 219);
  margin: 1rem 0;
}
.diviner span {
  position: absolute;
  background-color: #fff;
  left: 0;
  right: 0;
  top: -10px;
  margin: auto;
  width: 50px;
  line-height: 1;
  text-align: center;
  color: #969696;
  font-weight: 300;
}
.social-title {
  font-weight: 300;
  color: #969696;
  text-align: center;
  font-size: 14px;
}
.sign-in_button {
  background-color: rgb(52, 174, 196);
  text-align: center;
  color: #fff;
  width: 100%;
  line-height: 36px;
  border-radius: 4px;
  font-weight: 600;
}
.sign-in_button:disabled {
  opacity: 0.3;
}
.sign-in-dialog_wrapper .bottom {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  padding: 1rem;
  padding-top: 0;
}
.sign-in-dialog_wrapper .bottom button {
  background-color: transparent;
  color: rgb(160, 160, 160);
  transition: color 300ms ease;
}
.sign-in-dialog_wrapper .bottom button:hover {
  color: rgb(77, 75, 75);
}
.sign-in-dialog_wrapper .bottom .hor-div {
  width: 1px;
  height: 21px;
  background-color: rgb(221, 221, 221);
}
.sign-in-dialog_close-button {
  position: absolute;
  top: 0;
  right: 0;
  background-color: transparent;
  padding: 0.2rem;
  outline: 0;
  color: rgb(196, 196, 196);
  transition: color 300ms ease;
}
.sign-in-dialog_close-button:hover {
  color: rgb(70, 70, 70);
}
.type {
  color: #707070;
  font-size: 12px;
  margin-top: 1rem;
}
@media (max-width: 600px) {
  .time-select .time {
    width: 33.333%;
  }
}
@media (max-width: 660px) {
  .appointment-dialog .appointment-dialog_wrapper .right-side {
    width: 100%;
    max-width: 100%;
  }
  .appointment-dialog .appointment-dialog_wrapper {
    flex-direction: column-reverse;
    width: 360px;
  }
  .appointment-dialog .fullinfo-wrap {
    flex-direction: row;
  }
  .appointment-dialog .appointment-dialog_wrapper .right-side .avatar {
    margin: 0;
    flex: 0 0 100px;
    height: 100px;
    width: 100px;
  }
  .appointment-dialog .appointment-dialog_wrapper .right-side .name {
    text-align: left;
  }
  .appointment-dialog .appointment-dialog_wrapper .right-side .appointment-time {
    justify-content: flex-start;
    margin-top: 0.5rem;
  }
  .appointment-dialog .appointment-dialog_wrapper .right-side .appointment-dialog-button {
    margin-top: 1rem;
  }
  .appointment-dialog .appointment-dialog_wrapper .hint-overlay {
    align-items: flex-end;
    justify-content: center;
  }
  .appointment-dialog .appointment-dialog_wrapper .hint-overlay .hint {
    flex-direction: column-reverse;
  }
  .appointment-dialog .appointment-dialog_wrapper .hint-overlay i {
    margin: 0;
    transform: rotate(-90deg);
  }
  .info-wrap {
    text-align: left;
    margin-left: 1rem;
  }
  .type {
    margin-top: 0;
  }
}
@media (max-width: 580px) {
  .doctor-item .bottom {
    display: flex;
  }
  .doctor-item .actions {
    display: none;
  }
  .doctor-item .top {
    align-items: center;
  }
  .doctor-item .right-side {
    margin-top: 0;
  }
  .doctor-item .avatar {
    width: 70px;
    height: 70px;
    flex: 0 0 70px;
  }
  .doctor-item .avatar .placeholder {
    width: 50px;
  }
}
@media (max-width: 520px) {
  .time-select {
    flex-direction: column;
  }
  .time-select .time {
    width: 20%;
  }
  .time-select .right-side {
    margin-left: 0;
  }
  .time-select .date-selector {
    width: 100%;
    margin-bottom: 12px;
  }
  .appointment-dialog .appointment-dialog_wrapper .right-side .name {
    font-size: 15px;
  }
  .appointment-dialog .appointment-dialog_wrapper .right-side .type,
  .appointment-dialog .appointment-dialog_wrapper .right-side .description {
    font-size: 11px;
  }
  .appointment-dialog .appointment-dialog_wrapper .right-side .appointment-time {
    font-size: 12px;
  }
  .appointment-dialog .appointment-dialog_wrapper .right-side .appointment-time .date i,
  .appointment-dialog .appointment-dialog_wrapper .right-side .appointment-time .time i {
    font-size: 16px;
  }
  .appointment-dialog .appointment-dialog_wrapper .right-side .avatar {
    flex: 0 0 90px;
    height: 90px;
    width: 90px;
  }
  .appointment-dialog .appointment-dialog_wrapper .right-side .appointment-dialog-button {
    margin-top: 0.5rem;
  }
  form {
    padding: 0.5rem 1rem;
  }
}
@media (max-width: 410px) {
  .doctor-item .bottom button {
    font-size: 10px;
  }
  .time-select .time {
    width: 25%;
  }
}
</style>


<style>
.landing-selector.vs--open,
.landing-selector:hover {
  border: 1px solid transparent;
  box-shadow: 0 1px 6px 2px rgba(0,0,0,.1);
}
.landing-selector.vs--open {
  border-radius: 24px 24px 0 0;
}
.landing-selector .vs__dropdown-toggle {
  width: 100%;
}
.landing-selector .vs__dropdown-menu {
  top: 100%;
  padding: 0;
  left: -1px;
  right: -1px;
  width: auto;
  border-top: 1px solid rgba(0,0,0,.1);
  box-shadow: 0 4px 6px 2px rgba(33, 33, 33, .1);
  border-radius: 0 0 12px 12px;
  padding-bottom: 12px;
  padding-top: 6px;
}
.landing-selector .vs__clear,
.landing-selector .vs__open-indicator {
  color: rgba(0, 0, 0, .3);
}
.landing-selector .vs__dropdown-option--highlight {
  background-color: rgba(0,0,0,.05);
  color: #424242;
}
</style>